var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.scY > 300),expression:"scY > 300"}],staticClass:"scroll-top",on:{"click":_vm.toTop}},[_c('v-icon',{staticClass:"fa-solid fa-arrow-up"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }